import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import EmployeeTabs from '@/components/employees/EmployeeTabs.vue';
    import { computed, ref } from 'vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { useDateFormat } from '@/composables/useDateFormat';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateEmployee',
  setup(__props) {

    const { formatDateForRegex } = useDateFormat();

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const tabs = ref<InstanceType<typeof EmployeeTabs>>();

    const form = useForm({
        // Employment
        employment: {
            employment_type: 'CustomerSalariedEmployee',
            weekly_working_days: null,
            weekly_working_hours: null,
            salary: null,
            hourly_rate: null,
            tax_card: null,

            has_free_car: false,
            free_car_monthly: null,
            free_car_file: null,
            free_car_file_description: '',
            remove_free_car_file: false,

            kilometer: false,

            has_free_phone: false,

            has_lunch_arrangement: false,
            lunch_arrangement_monthly: '',

            has_fixed_add_ons: false,
            fixed_add_ons_monthly: '',

            has_pension: false,
            health_insurance: false,

            danmarks_statistik: false,
            dst_salary_form: '',
            dst_job_status: '',
            dst_hired_terms: '',
            disco_code: '',
            dst_time_limited_employment: '',
        },

        // Optional
        optional: {
            flex_savings: '',
            days_vacation: '',
            allocation_of_vacation_days: '',
        },

        // Personal
        customer_employees: {
            company_id: selectedCompanyId.value,
            first_name: '',
            last_name: '',
            cpr: '',
            email: '',
            phone_cell: '',
            department: '',
            production_unit: null,
            employment_date: null,
        },

        // Address
        address: {
            main: {
                address: '',
                address2: '',
                postal_code: '',
                city: '',
                country_code: 'DK',
            },
        },

        // Bank
        bank: {
            bank_reg: '',
            bank_account: '',
            iban: '',
            swift: '',
            use_iban: false,
        },

        // Pension
        companyPension: {
            type: 'percentage',
            employee_contribution: '',
            company_contribution: '',
            pension_company: '',
        },

        // Credit cards
        credit_cards: [],

        // User
        user: {
            id: null,
            create_user: 0,
            create_user_name: '',
            create_user_email: '',
        },
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.salary.employees.store'),
    "query-key": [_unref(QueryKey).EMPLOYEES, selectedCompanyId.value],
    title: "employee.create.header",
    "success-message": "companies.save_success",
    "button-text": "employee.create.header",
    "modal-size": "sm:max-w-xl",
    transform: 
            (data) => {
                Object.keys(data.optional).forEach((key) => {
                    if ([null, undefined, ''].includes(data.optional[key])) {
                        delete data.optional[key];
                    }
                });

                if (!data.employment.danmarks_statistik) {
                    [
                        'dst_salary_form',
                        'dst_job_status',
                        'dst_hired_terms',
                        'disco_code',
                        'dst_time_limited_employment',
                    ].forEach((field) => {
                        delete data.employment[field];
                    });
                }

                if (!data.employment.has_lunch_arrangement) {
                    delete data.employment.lunch_arrangement_monthly;
                }
                if (!data.employment.has_fixed_add_ons) {
                    delete data.employment.fixed_add_ons_monthly;
                }

                if (!data.employment.has_free_car) {
                    delete data.employment.free_car_monthly;
                    delete data.employment.free_car_file;
                    delete data.employment.free_car_file_description;
                }

                return {
                    ...data,
                    addresses: true,
                    customer_employees: {
                        ...data.customer_employees,
                        employment_date: data.customer_employees.employment_date
                            ? _unref(formatDateForRegex)(data.customer_employees.employment_date)
                            : '',
                    },
                };
            }
        
  }, {
    default: _withCtx(() => [
      _createVNode(EmployeeTabs, {
        form: _unref(form),
        ref_key: "tabs",
        ref: tabs
      }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "transform"]))
}
}

})